<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import EventBus from '../../../js/EventBus'

import { SupplierRoutes } from '../api/supplierRoutes'

import MyDropdown from './MyDropdown.vue'
import AppButton from '~/components/UI/app-button/AppButton.vue'

import ConnectStore from './ConnectStore'

export default {
  components: {
    AppButton,
    MyDropdown,
    ConnectStore,
  },
  data: () => ({
    appName: window.config.appName,
    userNAME: '',
    firstname: '',
    lastname: '',
    displayname: '',
    loginAsSupplier: false,
    intervalId: null,
  }),

  watch: {
    importProgress: function (newValue, oldValue) {
      if (oldValue.status !== newValue.status) {
        this.fetchProductImportProgress(newValue.status)
      }
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      importProgress: 'progress/importProgress',
    }),

    hasStore() {
      return this.user?.store?.length > 0
    },
  },

  created() {
    this.userMenu()
    this.fetchInitialProductImportProgress()
  },
  mounted() {
    this.updateHeaderHeight()
    window.addEventListener('resize', this.updateHeaderHeight)

    EventBus.$on('show-connect-store-modal', () => {
      this.$refs.storeConnectButton.$el.click()
    })
  },

  unmounted() {
    EventBus.$off('show-connect-store-modal')

    clearInterval(this.intervalId)
    window.removeEventListener('resize', this.updateHeaderHeight)
  },

  methods: {
    updateHeaderHeight() {
      const header = document.getElementById('topnav')
      const headerHeight = header.offsetHeight - 1
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)
    },

    fetchInitialProductImportProgress: function (status) {
      axios
        .get(SupplierRoutes.importProductsStatus)
        .then((response) => {
          this.$store.dispatch('progress/updateImportProgress', response.data)
        })
        .catch((error) => {})
    },

    fetchProductImportProgress(status) {
      let self = this
      if (status) {
        this.intervalId = setInterval(function () {
          axios
            .get(SupplierRoutes.importProductsStatus)
            .then((response) => {
              self.$store.dispatch('progress/updateImportProgress', response.data)
            })
            .catch((error) => {})
        }, 10000)
      } else {
        clearInterval(this.intervalId)
      }
    },

    userMenu() {
      this.userNAME = this.user.name
      this.firstname = this.user.firstname
      this.lastname = this.user.lastname
      this.displayname = this.user.supplier ? this.user.supplier.name : this.user.name
    },
  },
}
</script>

<template>
  <div class="row">
    <header id="topnav">
      <div class="container-fluid">
        <nav class="navbar-custom">
          <div class="container-fluid row">
            <ul class="list-inline menu-left mb-0 col-sm-3">
              <li class="float-left">
                <router-link
                  :to="{ name: 'adminDashboard' }"
                  class="logo"
                >
                  <span class="logo-lg">
                    <img
                      src="/images/logo-white.svg"
                      alt=""
                      height="24"
                    >
                  </span>
                  <span class="logo-sm">
                    <img
                      src="/images/logo-white.svg"
                      alt=""
                      height="24"
                    >
                  </span>
                </router-link>
              </li>
            </ul>
            <ul class="navigation-menu col-sm-6 center-side-nav">
              <li class="has-submenu">
                <router-link :to="{ name: 'adminDashboard' }">
                  Dashboard
                </router-link>
              </li>
              <li class="has-submenu">
                <router-link :to="{ name: 'product' }">
                  Products
                </router-link>
              </li>
              <li class="has-submenu">
                <router-link
                  :to="{ name: 'orders' }"
                  class="import_icon"
                >
                  Orders
                </router-link>
              </li>
              <li class="has-submenu">
                <router-link
                  :to="{ name: 'payouts' }"
                  class="import_icon"
                >
                  Payouts
                </router-link>
              </li>
            </ul>
            <!-- End navigation menu -->
            <div
              class="client-part list-unstyled topbar-right-menu float-right mb-0 col-sm-3 right-side-nav drop-margin supplier-right-menu"
            >
              <span
                v-if="importProgress.status"
                class="tooltip-supplier-menu cursor-pointer"
              >
                <span class="upload-progress">
                  <img src="/images/imported.svg">
                  {{ importProgress.imported }}
                </span>
                <span class="tooltip-text-supplier-menu">Products imported</span>
              </span>
              <span
                v-if="user.store && user.store.length"
                class="tooltip-supplier-menu"
              >
                <a
                  :href="'https://' + user.store[0].store_url + '/admin'"
                  target="_blank"
                >
                  <img
                    class="store-icon"
                    src="/images/shopify_icon.svg"
                  >
                </a>
                <span class="tooltip-text-supplier-menu">
                  {{ user.store[0].store_name }}
                </span>
              </span>

              <app-button
                v-if="!hasStore"
                ref="storeConnectButton"
                variant="primary"
                size="small"
                data-target="#connect-store-modal"
                data-toggle="modal"
                prepend-icon="Shopify"
              >
                Connect a store
              </app-button>
              <my-dropdown :name="displayname" />
            </div>
          </div>
        </nav>
        <!-- end topbar-main -->
      </div>
    </header>
    <!-- include connect store modal -->
    <connect-store />
  </div>
</template>

<style lang="scss" scoped>
.client-part {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  column-gap: 1rem;
}

.store-icon {
  font-size: 16px;
}
</style>
